import { makeStyles, Tooltip } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import LanguageContext from '../../contexts/languageContext';
import BreadCrumbsView from './BreadCrumbsView';

const styles = makeStyles((theme) => ({
    wrapper: {
        [theme.breakpoints.down(1025)]: {
            position: 'relative'
        }
    },
    tooltipChild: ({ rtl }) => ({
        position: 'absolute',
        bottom: '5px',
        left: rtl ? '100px' : 'unset',
        right: rtl ? 'unset' : '100px',
        width: '2px',
        height: '2px',
        [theme.breakpoints.up(1025)]: {
            top: '45px'
        }
    }),
    customTooltip: {
        width: '100%',
        background: '#ebf0ff',
        color: '#545e66',
        minHeight: '65px',
        maxWidth: 'unset',
        [theme.breakpoints.up(1025)]: {
            fontSize: '12px',
            minHeight: '100px'
        }
    },
    customArrow: ({ rtl }) => ({
        color: '#ebf0ff',
        marginTop: '-6px !important',
        marginLeft: rtl ? '-1.5em !important' : 'unset',
        marginRight: rtl ? 'unset' : '-1.5em !important',
        width: '1.5em !important',
        height: '2em !important'
    }),
    tooltipPlacement: ({ rtl }) => ({
        minWidth: '100%',
        marginLeft: rtl ? '24px !important' : '16px !important',
        marginRight: rtl ? '16px !important' : '24px !important'
    }),
    tooltipPopper: {
        width: '80vw',
        [theme.breakpoints.up(1025)]: {
            width: 'calc(100vw - 260px)'
        }
    }
}));
const BreadCrumbs = () => {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const [isOverFlow, setIsOverFlow] = useState(false);
    const [open, setOpen] = useState(false);
    const handleTooltipClose = () => {
        setOpen(false);
    };

    return (
        <div className={classes.wrapper}>
            <Tooltip
                classes={{
                    tooltip: classes.customTooltip,
                    arrow: classes.customArrow,
                    tooltipPlacementRight: classes.tooltipPlacement,
                    popper: classes.tooltipPopper
                }}
                title={
                    <BreadCrumbsView setIsOverFlow={setIsOverFlow} setOpen={setOpen} isInTooltip />
                }
                interactive
                placement={lang === 'fa' ? 'left' : 'right'}
                onClose={handleTooltipClose}
                open={open && isOverFlow}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                PopperProps={{
                    disablePortal: true
                }}
                arrow
            >
                <span className={classes.tooltipChild} />
            </Tooltip>
            <BreadCrumbsView
                setIsOverFlow={setIsOverFlow}
                setOpen={setOpen}
                isOverFlow={isOverFlow}
            />
        </div>
    );
};

export default BreadCrumbs;
